import styled from 'styled-components';

import { P } from '../../typography';

/* ----------------------------- StyledFormBlock ---------------------------- */

export const StyledFormBlock = styled.form(
    ({ theme }) => `
        padding: 2.5rem 2rem 2rem;
        background-color: ${theme.sections.page.d};
        border-radius: 0.5rem;
    `,
);

/* ------------------------------ SubmitButton ------------------------------ */

export const SubmitButton = styled.button(
    ({ theme }) => `
        background-color: ${theme.sections.page.feature};
        color: ${theme.sections.page.featureText};
        border: none;
        padding: 0.875rem;
        width: 100%;
        border-radius: 0.3rem;
        line-height: 1;
        margin-top: 0.4rem;
        cursor: pointer;
        transition: background 0.33s;
        box-shadow: 0 2px 3px 0 rgba(0,0,0,0.3);
        outline: none;

        font-size: 1rem;
        @media screen and (min-width: 48rem) {
            font-size: 1.125rem;
        }

        &:hover,
        &:focus {
            @media (hover: hover) {
                background-color: ${theme.sections.page.featureMouseover};
                color: ${theme.sections.page.featureMouseoverText};
            }
        }

        &:active {
            transform: scale(0.95);
            box-shadow: none;
        }

        &:disabled {
            &:active {
                transform: none;
            }
        }


    `,
);

/* ------------------------------- Disclaimer ------------------------------- */

export const Disclaimer = styled(P)(
    ({ theme }) => `
        font-size: 0.875rem;
        margin-top: 1.5rem;
        padding: 0;
        color: ${theme.sections.page.a};
        line-height: 130%;

        a {
            color: ${theme.sections.page.feature};

            &:hover {
                text-decoration: none;
            }
        }
    `,
);
